import React, { useEffect, useState } from "react";
import { job, StewardReportDetail_ui } from "../../../services/dtos";
import jobServices from "../../../services/jobServices";
import { Button } from "../Button";
import { Modal } from "../Modal";
interface MassTextModalProps {
  showMassTextModal: boolean;
  setShowMassTextModal: React.Dispatch<React.SetStateAction<boolean>>;
  detailedJobRecords: StewardReportDetail_ui[];
  selectedJob: job;
  setSentSmsSuccessfully: React.Dispatch<React.SetStateAction<boolean>>;
  setErrorWhileSendingSms: React.Dispatch<React.SetStateAction<boolean>>;
  errorWhileSendingSms: boolean;
}
export const MassTextModal = ({
  showMassTextModal,
  setShowMassTextModal,
  detailedJobRecords,
  selectedJob,
  setSentSmsSuccessfully,
  setErrorWhileSendingSms,
  errorWhileSendingSms,
}: MassTextModalProps) => {
  const [modalStep, setModalStep] = useState(1);
  const [memberMassTextMap, setMemberMassTextMap] = useState(
    detailedJobRecords.map((detailedJob) => {
      return {
        uniqueMemberId: detailedJob.unique_member_id,
        sendMassText: true,
        memberName: detailedJob.member_name,
      };
    })
  );
  const [clearAll, setClearAll] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [smsMessage, setSmsMessage] = useState("");

  const handleMassTextSubmit = (modalStep: number) => {
    if (modalStep === 1) {
      setModalStep(2);
    } else {
      setIsLoading(true);
      try {
        const jsvc = new jobServices();
        jsvc
          .massTextFromStewReport(
            selectedJob.job_ID,
            smsMessage,
            memberMassTextMap
              .filter((member) => member.sendMassText)
              .map((member) => member.uniqueMemberId)
          )
          .then(() => {
            setSentSmsSuccessfully(true);
            setTimeout(() => {
              setSentSmsSuccessfully(false);
            }, 5000);
            setIsLoading(false);
            setShowMassTextModal(false);
          })
          .catch((err) => {
            setIsLoading(false);
            console.error("error while sending mass text", err);
            setTimeout(() => {
              setErrorWhileSendingSms(false);
            }, 5000);
          });
      } catch (e) {
        setIsLoading(false);
        console.error("error while sending mass text", e);
        setTimeout(() => {
          setErrorWhileSendingSms(false);
        }, 5000);
      }
    }
  };

  useEffect(() => {
    setMemberMassTextMap((prevMap) =>
      prevMap.map((member) => {
        return {
          ...member,
          sendMassText: !clearAll,
        };
      })
    );
  }, [clearAll]);

  return (
    <Modal
      popup={false}
      size={"6xl"}
      show={showMassTextModal}
      onClose={() => setShowMassTextModal(false)}
    >
      {modalStep === 1 && (
        <>
          <Modal.Header>Start Mass Text</Modal.Header>
          <Modal.Body>
            <div className="py-3 text-gray-900 dark:text-white">
              JOB ID - {selectedJob.job_ID}
            </div>
            <div className="py-5">
              <label
                htmlFor="sms_message"
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
              >
                SMS message text
              </label>
              <textarea
                id="sms_message"
                onChange={(e) => {
                  setSmsMessage(e.target.value);
                }}
                value={smsMessage}
                rows={4}
                className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder="Enter text for SMS message..."
              ></textarea>
            </div>

            <div className="mx-auto flex flex-col gap-8  dark:text-gray-400">
              <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                  <tr>
                    <th scope="col" className="py-3 px-6">
                      Employee Name
                    </th>

                    <th scope="col" className="py-3 px-6">
                      Send message?
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {memberMassTextMap &&
                    memberMassTextMap.map((detailedJob) => {
                      return (
                        <tr
                          className="bg-white border-b dark:bg-gray-900 dark:border-gray-700"
                          key={detailedJob.uniqueMemberId}
                        >
                          <td className="py-4 px-6">
                            {detailedJob.memberName}
                          </td>
                          <td className="py-4 px-6">
                            <div className="flex items-center">
                              <input
                                checked={detailedJob.sendMassText}
                                id="checked-checkbox"
                                type="checkbox"
                                onChange={() => {
                                  const memberId = detailedJob.uniqueMemberId;
                                  setMemberMassTextMap((prevMap) =>
                                    prevMap.map((member) =>
                                      member.uniqueMemberId === memberId
                                        ? {
                                            ...member,
                                            sendMassText: !member.sendMassText,
                                          }
                                        : member
                                    )
                                  );
                                }}
                                className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                              />
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
              <Button
                color={clearAll ? "success" : "failure"}
                onClick={() => {
                  setClearAll(!clearAll);
                }}
              >
                {clearAll ? "Select All" : "Clear All"}
              </Button>
            </div>
          </Modal.Body>
        </>
      )}

      {modalStep === 2 && (
        <>
          <Modal.Header>Are you sure?</Modal.Header>
          <Modal.Body>
            <div className="py-3">JOB ID - {selectedJob.job_ID}</div>

            <div className="py-3">
              You are about to send a mass text that reads - "{smsMessage}" to
              the following customers:
              <ul className="max-w-md space-y-1 text-gray-500 list-disc list-inside dark:text-gray-400">
                {memberMassTextMap
                  .filter((member) => member.sendMassText)
                  .map((member) => {
                    return (
                      <li key={member.uniqueMemberId}>{member.memberName}</li>
                    );
                  })}
              </ul>
            </div>
          </Modal.Body>
        </>
      )}

      <Modal.Footer>
        <Button
          disabled={!smsMessage}
          onClick={() => {
            handleMassTextSubmit(modalStep);
          }}
        >
          {modalStep === 1 ? (
            "Next"
          ) : isLoading ? (
            <div role="status">
              <svg
                aria-hidden="true"
                className="w-8 h-8 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
                viewBox="0 0 100 101"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                  fill="currentColor"
                />
                <path
                  d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                  fill="currentFill"
                />
              </svg>
              <span className="sr-only">Loading...</span>
            </div>
          ) : (
            `Submit`
          )}
        </Button>
        {modalStep === 2 && (
          <Button color="gray" onClick={() => setModalStep(1)}>
            Back
          </Button>
        )}
        {errorWhileSendingSms && (
          <p style={{ color: "red" }}>Error while sending SMS!</p>
        )}
      </Modal.Footer>
    </Modal>
  );
};
